import React, { useMemo, useState, useEffect } from "react";
import { Accordion } from "Components/Base/Surfaces/Accordion";
import { Checkbox } from "Components/Base/Inputs/Checkbox";
import { useSelectFilter } from "../../hooks";
import { STYLE_DETAILS } from "../../styles";
import { FILTER_GROUP_THRESHOLD } from "../../constants";

const SelectFilter = ({
  label,
  value,
  onChange,
  menuItems,
  defaultMenuItemLabel,
  categoryName,
  sx,
  isMobile = false,
  totalFilterGroupsCount = 0,
  alwaysExpanded = false,
}) => {
  const { selectId, selectedValues, handleToggle } = useSelectFilter({
    value,
    categoryName,
    onChange,
  });

  const detailsContent = (
    <div id={selectId} style={{ ...STYLE_DETAILS, ...sx }}>
      {menuItems?.map((item) => (
        <div key={`${selectId}-${item.value}`}>
          <Checkbox
            id={`${selectId}-${item.value}`}
            label={item.title}
            checked={selectedValues.has(item.value)}
            onChange={() => handleToggle(item.value)}
            disableRipple={true}
            size="medium"
          />
        </div>
      ))}
    </div>
  );

  const hasActiveSelection = useMemo(() => {
    if (Array.isArray(value)) {
      return value.length > 0;
    }
    return value !== 0 && value !== null && value !== undefined && value !== "";
  }, [value]);

  const shouldExpandByCount = totalFilterGroupsCount < FILTER_GROUP_THRESHOLD;
  const defaultExpanded =
    hasActiveSelection || shouldExpandByCount || alwaysExpanded;
  const [expanded, setExpanded] = useState(defaultExpanded);

  useEffect(() => {
    if (defaultExpanded) {
      setExpanded(true);
    }
  }, [defaultExpanded]);

  const handleAccordionChange = (_, nextExpanded) => {
    setExpanded(nextExpanded);
  };

  if (isMobile) {
    return (
      <Accordion
        id={`${selectId}-accordion`}
        summaryText={label}
        summaryVariant="h3"
        detailsText={detailsContent}
        expanded={expanded}
        onChange={handleAccordionChange}
        disableGutters={false}
        border={false}
        boxShadow={false}
        slotProps={{
          details: {
            sx: {
              padding: "4px 8px 8px !important",
            },
          },
        }}
      />
    );
  }

  return (
    <Accordion
      id={`${selectId}-accordion`}
      summaryText={label}
      summaryVariant="h3"
      detailsText={detailsContent}
      expanded={expanded}
      onChange={handleAccordionChange}
      disableGutters={true}
      border={false}
      boxShadow={false}
    />
  );
};

export default SelectFilter;
